/**
 * AndVDualAxes - 双轴图组件
 * 基于 Ant Design Charts DualAxes
 */
import React from 'react';
import { DualAxes } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVDualAxesProps } from '../base/types';

// 使用 HOC 包装基础 DualAxes 组件
const DualAxesWithBase = withBaseChart<AndVDualAxesProps>(DualAxes, {
  chartType: 'AndVDualAxes',
  defaultHeight: 300,
  defaultData: [
    { year: '1991', value: 3, count: 10 },
    { year: '1992', value: 4, count: 4 },
    { year: '1993', value: 3.5, count: 5 },
    { year: '1994', value: 5, count: 5 },
    { year: '1995', value: 4.9, count: 4.9 },
    { year: '1996', value: 6, count: 35 },
    { year: '1997', value: 7, count: 7 },
    { year: '1998', value: 9, count: 1 },
    { year: '1999', value: 13, count: 20 },
  ],
});

/**
 * AndVDualAxes 双轴图组件
 */
export const AndVDualAxes: React.FC<AndVDualAxesProps> = (props) => {
  const {
    // 字段
    xField,
    yField,
    seriesField,
    colorField,
    // JSON 配置
    children,
    ...baseProps
  } = props;

  const chartProps: Record<string, any> = {
    ...baseProps,
  };

  // 添加字段配置
  if (xField) chartProps.xField = xField;
  
  // yField 特殊处理：如果是 JSON 字符串则解析，如果是数组则直接使用
  const parsedYField = parseJsonProp(yField);
  if (parsedYField) {
      chartProps.yField = parsedYField;
  } else if (yField) {
      // 兼容直接传字符串的情况，虽然不推荐
      chartProps.yField = yField;
  }

  if (seriesField) chartProps.seriesField = seriesField;
  if (colorField) chartProps.colorField = colorField;

  // 解析 children 配置
  const childrenConfig = parseJsonProp(children);
  if (childrenConfig !== undefined) chartProps.children = childrenConfig;

  return <DualAxesWithBase {...chartProps} />;
};

export type { AndVDualAxesProps };
export default AndVDualAxes;
